import Ripple from 'vue-ripple-directive'
import { alphanumeric } from '@/mixins/alphanumeric'
import ProfileApis from '@/services/apis/profile'
import moment from '@/libs/moment'

const profile = new ProfileApis()
export default {
  directives: {
    Ripple,
  },
  mixins: [alphanumeric],
  data() {
    return {
      formData: {
        referralId: '',
      },
      moment,
      storeReferralPending: false,
      items: [],
      paginate: {
        page: 1,
        per_page: 10,
        total: 0,
      },
    }
  },
  computed: {
    computedFields() {
      return this.fields
    },
    page() {
      return this.paginate.page
    },
    fields() {
      return [
        { key: 'first_name', label: this.$t('name') },
        { key: 'last_name', label: this.$t('last_name') },
        { key: 'created_at', label: this.$t('date-registration') },
      ]
    },
  },
  watch: {
    page(val) {
      if (val) {
        this.getReferralId()
      }
    },
  },
  created() {
    this.getReferralId()
  },

  methods: {
    copyRefCode() {
      navigator.clipboard.writeText(`${process.env.VUE_APP_APP_URL}/${this.$route.params.lang}/register?refID=${this.formData.referralId}`)
      this.$swal({
        title: this.$t('referral-code-copied'),
        icon: 'success',
        timer: 2500,
        showConfirmButton: false,
      })
    },
    getReferralId() {
      profile.getReferralId(this.paginate).then(res => {
        this.formData.referralId = res.data.results.code
        this.items = res.data.results.users
        this.paginate.total = res.data.results.paginate.total
      })
    },
    storeReferralId() {
      this.storeReferralPending = true
      profile.storeReferralId({ code: this.formData.referralId }).then(res => {
        this.$swal({
          title: res.data.message,
          icon: 'success',
          timer: 2500,
          showConfirmButton: false,
        })
      }).finally(() => {
        this.storeReferralPending = false
      })
    },
  },

}
